import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayAddFavoriteClickedPayload {
  shiftId: string;
  professionalId?: string;
}

/**
 * Fires when an office clicks "Add to Favorites" within the end-of-day flow.
 * Event: dental_portal:end_of_day:add_favorite_clicked
 */
export function fireEndOfDayAddFavoriteClicked(
  payload: IEndOfDayAddFavoriteClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:add_favorite_clicked', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
  });
}
